export default "__VITE_ASSET__671dbbac__"